import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/feature/country/feature.country.query.gql"
import type {
  FeatureCountryQuery,
  FeatureCountryQueryVariables,
} from "@/v2-backoffice-client/feature/country/__types__/feature.country.query"

type Options = QueryHookOptions<
  FeatureCountryQuery,
  FeatureCountryQueryVariables
>

export function useFeatureCountryQuery(options?: Options) {
  return useQuery<FeatureCountryQuery, FeatureCountryQueryVariables>(
    query,
    options,
  )
}
